// src/contentful/contentfulClient.js
// GraphQL client for Contentful CMS integration

import { GraphQLClient } from 'graphql-request';

const SPACE_ID = process.env.REACT_APP_CF_SPACE_ID;
const ENV_ID = process.env.REACT_APP_CF_ENV_ID || 'master';
const ACCESS_TOKEN = process.env.REACT_APP_CF_CDA_TOKEN;

const endpoint = `https://graphql.contentful.com/content/v1/spaces/${SPACE_ID}/environments/${ENV_ID}`;

// Create GraphQL client with authorization
const client = new GraphQLClient(endpoint, {
  headers: {
    Authorization: `Bearer ${ACCESS_TOKEN}`,
  },
});

/**
 * Fetch data from Contentful GraphQL API
 * @param {string} query - GraphQL query string
 * @param {object} variables - Query variables
 * @returns {Promise<{data: any, error: Error|null}>}
 */
export const fetchContentful = async (query, variables = {}) => {
  // Validate environment variables
  if (!SPACE_ID || !ACCESS_TOKEN) {
    console.error('Contentful credentials missing. Check REACT_APP_CF_SPACE_ID and REACT_APP_CF_CDA_TOKEN');
    return {
      data: null,
      error: new Error('Contentful credentials not configured')
    };
  }

  try {
    const data = await client.request(query, variables);
    return { data, error: null };
  } catch (error) {
    console.error('Contentful fetch error:', error.message);
    return { data: null, error };
  }
};

export default client;
